import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "but_table_repeat",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "110",
  height: "40",
  viewBox: "0 0 110 40"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><linearGradient id=\"repeat-linear-gradient\" x1=\"0.5\" x2=\"0.5\" y2=\"1\" gradientUnits=\"objectBoundingBox\"><stop offset=\"0\" stop-color=\"#dfca44\"></stop><stop offset=\"1\" stop-color=\"#a69525\"></stop></linearGradient><linearGradient id=\"repeat-linear-gradient-2\" x1=\"0.5\" x2=\"0.5\" y2=\"1\" gradientUnits=\"objectBoundingBox\"><stop offset=\"0\" stop-color=\"#fbffb9\"></stop><stop offset=\"1\" stop-color=\"#806210\"></stop></linearGradient></defs><g id=\"but_more\"><rect id=\"Rectangle_45\" data-name=\"Rectangle 45\" width=\"110\" height=\"40\" rx=\"5\" fill=\"url(#repeat-linear-gradient)\"></rect><path id=\"矩形_46\" data-name=\"矩形 46\" d=\"M5,1A4,4,0,0,0,1,5V35a4,4,0,0,0,4,4H105a4,4,0,0,0,4-4V5a4,4,0,0,0-4-4H5M5,0H105a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z\" fill=\"url(#repeat-linear-gradient-2)\"></path></g>", 2)
const _hoisted_4 = {
  id: "重複投注",
  transform: "translate(33 26)",
  fill: "#fff",
  "font-size": "16",
  "font-family": "PingFangSC-Regular, PingFang SC"
}
const _hoisted_5 = {
  x: "0",
  y: "0"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_482",
  "data-name": "Path 482",
  d: "M14.653,17.218A8.059,8.059,0,0,1-1.154,15c-.362.759-1.339,2.869-1.339,2.869",
  transform: "translate(11.492 5)",
  fill: "none",
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_483",
  "data-name": "Path 483",
  d: "M-2.493,20.84a8.059,8.059,0,0,1,15.807,2.218c.362-.759,1.339-2.869,1.339-2.869",
  transform: "translate(13.198 -3.058)",
  fill: "none",
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("circle", {
  id: "Ellipse_171",
  "data-name": "Ellipse 171",
  cx: "6",
  cy: "6",
  r: "6",
  transform: "translate(12.5 14)",
  fill: "#fff"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_556",
  "data-name": "Path 556",
  d: "M3.722,3.233a4.278,4.278,0,0,1,2.187.552l.351-1.036A4.022,4.022,0,0,0,4.14,2.141V.8H3.183V2.164C1.556,2.355.8,3.312.8,4.337c0,1.1.78,1.846,2.671,2.365,1.22.315,1.8.653,1.8,1.317S4.535,9.1,3.425,9.1a4.484,4.484,0,0,1-2.451-.63L.622,9.5a4.474,4.474,0,0,0,2.506.7V11.5h.956v-1.34c1.67-.2,2.484-1.216,2.484-2.229,0-1.262-.693-1.881-2.518-2.387C2.634,5.124,2.1,4.764,2.1,4.246,2.1,3.785,2.425,3.233,3.722,3.233Z",
  transform: "translate(15.082 14.007)",
  fill: "#b3a12c",
  "fill-rule": "evenodd"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("text", _hoisted_4, [
      _createElementVNode("tspan", _hoisted_5, _toDisplayString(_ctx.text), 1)
    ]),
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
  ]))
}